import React from "react";
import { Typography } from "@kelp-dao/kernel-design-system";
import VaultSearch from "./VaultSearch";
import { TotalTvlData } from "./types";

interface VaultHeaderProps {
  totalTvlData: TotalTvlData;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const VaultHeader: React.FC<VaultHeaderProps> = ({
  totalTvlData,
  searchQuery,
  onSearchChange,
}) => {
  return (
    <div className="flex flex-col tablet:flex-row justify-start tablet:justify-between items-center w-full gap-4">
      <div className="flex flex-col gap-1 w-full">
        <Typography
          as="h1"
          type="heading"
          variant="default"
          className="w-full text-2xl font-medium xl:text-[24px] 4xl:text-[32px] 4xl:leading-[36px] font-sans"
        >
          Explore our vaults
        </Typography>
        <Typography
          type="body"
          variant="xsmall"
          className="text-text-secondary text-xs md:text-sm"
        >
          Deposit to vaults and earn the highest yield on your assets.
        </Typography>
      </div>

      <div className="flex gap-6 justify-between tablet:justify-end items-start w-full tablet:w-[40%]">
        <div className="flex flex-col gap-0.5">
          <Typography
            type="misc"
            as="p"
            variant="overline"
            className="text-text-secondary text-xs md:text-sm lg:text-[10px] xl:text-sm"
          >
            Total value locked
          </Typography>
          {totalTvlData.totalTvlLoading ? (
            <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" />
          ) : (
            <Typography
              type="heading"
              variant="xxsmall"
              className="text-text-primary font-sans"
            >
              {totalTvlData.formattedTotalTvl}
            </Typography>
          )}
        </div>
        <VaultSearch
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
        />
      </div>
    </div>
  );
};

export default VaultHeader;
